module.exports = __webpack_public_path__ + "img/user.c82b446f.svg";